
import { AppConfig } from "../Models/Models";
import RespondClient from "../Models/RespondClient";
import { getApiHost } from "../util";
import { getInstance } from "./InstanceProvider";

export default class ConfigurationProvider {
    public configurationProvider: ConfigurationProvider | undefined;

    public init() {
        if (!this.configurationProvider) {
            this.configurationProvider = new ConfigurationProvider();
        }
    }

    public get(): Promise<RespondClient<AppConfig>> {
        return getInstance().get(`${getApiHost()}/configuration`);
    }
}

export const ConfigurationProviderInstance = new ConfigurationProvider();
